import type { WidgetDefinition } from '../WidgetDefinition';
import { faBasketShopping } from '@fortawesome/pro-regular-svg-icons/faBasketShopping';
import type { BasketTradingWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { BasketTradingWidgetViewModel } from 'src/store/types';

class BasketTradingWidgetDefinition implements WidgetDefinition<
    BasketTradingWidgetViewModel,
    BasketTradingWidgetModel
> {
    type = 'basket-trading' as const;
    nameKey = 'widgets::basket-trading::name' as const;
    roles = ['widgets::basket-trading'];
    icon = faBasketShopping;
    category = 'widgets::categories::trading' as const;

    toViewModel(widget: BasketTradingWidgetModel): BasketTradingWidgetViewModel {
        return {
            ...widget,
        };
    }

    toContractModel(widget: BasketTradingWidgetViewModel): BasketTradingWidgetModel {
        return {
            ...widget,
        };
    }
}

export const basketTradingWidgetDefinition = new BasketTradingWidgetDefinition();
